import { render, staticRenderFns } from "./CompanyFundingListBlock.vue?vue&type=template&id=5457708e&scoped=true"
import script from "./CompanyFundingListBlock.vue?vue&type=script&lang=js"
export * from "./CompanyFundingListBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5457708e",
  null
  
)

export default component.exports